import { useState } from "react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { hpSah, periksaKunciHp, pesanHpTidakSah } from "../../lib/noHp";

/** Form sempit "Lengkapi No HP" nota lama (brief owner 22 Sep 2026, I1).
 *
 *  Kredit tukar unit hanya bisa dipakai pelanggan dengan nama DAN No HP yang
 *  sama, jadi nota tanpa No HP yang sah tidak bisa diretur tukar unit. Nota
 *  lama tidak bisa diedit lagi (jendela 60 menit), jadi SPV ke atas yang
 *  melengkapinya — `POST /retur/penjualan/nota/{id}/lengkapi-no-hp`, gerbang
 *  JABATAN (jawaban owner 29b, 24 Sep 2026), lebih sempit dari approve retur.
 *  Dirender HANYA oleh `GerbangLengkapiNoHp` (jawaban server = true), supaya
 *  tidak ada tombol yang berujung 403 (aturan #3) — halaman tidak memakainya
 *  langsung (dijaga tes AST di `tests/test_i1_layar.py`).
 *
 *  `prefix` = awalan data-testid (mis. "retur-ajukan" / "rt-jual").
 */
export default function LengkapiNoHpNota({ saleId, prefix, onSelesai }) {
  const [noHp, setNoHp] = useState("");
  const [alasan, setAlasan] = useState("");
  const [menyimpan, setMenyimpan] = useState(false);
  const cek = periksaKunciHp(noHp);
  const siap = hpSah(noHp) && alasan.trim().length > 0 && !menyimpan;

  const simpan = async () => {
    if (!siap) return;
    setMenyimpan(true);
    try {
      const { data } = await api.post(`/retur/penjualan/nota/${saleId}/lengkapi-no-hp`,
        { no_hp: noHp, alasan: alasan.trim() });
      toast.success(data.message || "No HP nota dilengkapi");
      onSelesai?.(data.no_hp);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Gagal melengkapi No HP nota");
    } finally {
      setMenyimpan(false);
    }
  };

  return (
    <div className="mt-2 rounded-lg border border-violet-200 bg-violet-50/60 p-3 space-y-2"
         data-testid={`${prefix}-lengkapi-hp-box`}>
      <p className="text-[11px] text-violet-900">
        Pelanggan datang untuk tukar unit? Sebagai SPV/atasan, Anda bisa melengkapi No HP
        nota ini (tercatat dengan alasan). Pastikan nomornya milik pelanggan yang meretur.
      </p>
      <input value={noHp} onChange={e => setNoHp(e.target.value)} placeholder="No HP pelanggan (08xx…)"
        data-testid={`${prefix}-lengkapi-hp`}
        className="w-full h-9 px-3 rounded-lg border border-slate-200 text-sm bg-white" />
      {noHp.trim() && !cek.kunci && (
        <p className="text-[11px] text-rose-700">{pesanHpTidakSah(cek.alasan)}</p>
      )}
      <input value={alasan} onChange={e => setAlasan(e.target.value)}
        placeholder="Alasan (wajib), mis. HP dikonfirmasi langsung ke pelanggan"
        data-testid={`${prefix}-lengkapi-alasan`}
        className="w-full h-9 px-3 rounded-lg border border-slate-200 text-sm bg-white" />
      <button type="button" onClick={simpan} disabled={!siap} data-testid={`${prefix}-lengkapi-simpan`}
        className="h-9 px-4 rounded-lg bg-violet-600 hover:bg-violet-700 disabled:opacity-40 disabled:cursor-not-allowed text-white text-xs font-medium">
        {menyimpan ? "Menyimpan..." : "Lengkapi No HP"}
      </button>
    </div>
  );
}
